const siteConfig = {
  brandName: "curchasefox",
  logo: "/head/curchasefox-wordmark.svg",
  description:
    "Artisan cheese, fresh market produce and pantry favourites selected for Hong Kong tables.",
  contact: {
    email: "server@curchasefox.online",
    address: "222 Tampines Street 24, Block 222, Singapore 521222",
    hours: "Monday–Saturday, 9am–6pm",
  },
  currency: {
    code: "USD",
    symbol: "$",
    locale: "en-US",
  },
  delivery: {
    standardFee: 9.99,
    freeThreshold: Number.POSITIVE_INFINITY,
    orderCutoff: "4pm",
    promise: "Order before 4pm for next-day delivery",
  },
  storage: {
    cartKey: "curchasefox-cart",
    wishlistKey: "curchasefox-wishlist",
  },
  announcement:
    "Carefully packed delivery · USD 9.99 per order",
  policyEffectiveDate: "16 October 2026",
};

export const formatPrice = (value) =>
  new Intl.NumberFormat(siteConfig.currency.locale, {
    style: "currency",
    currency: siteConfig.currency.code,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(value);

export default siteConfig;
